<div class="page-shell">
  <wb-session-list [sessions]="$sessions()" [limit]="$limit()" [title]="$title()" (endSession)="endSession.emit($event)" (endAll)="endAll.emit()" (tryAgain)="tryAgain.emit()">
    <img wbSessionListLogo [src]="$logoSrc()" alt="WorkBuddy" />
  </wb-session-list>
</div>
